export default __webpack_public_path__ + "b22679938be32b6efc4dd8e79a474236.jpg";